<template>
  <header class="header">
    <div class="inner">
      <div class="header_top">
        <div class="inner">
          <div class="btn_wrap" v-if="$Util.isEmpty(userData)">
            <!--로그인 전-->
            <button class="btn bo grey" @click="fnPage(1)">회원가입</button>
            <button class="btn bo grey" @click="fnPage(2)">로그인</button>
          </div>
          <div class="btn_wrap" v-else>
            <!--로그인 후-->
            <!--로그인 후-->
            <button class="btn bo grey" @click="fnLogout">로그아웃</button>
          </div>
        </div>
      </div>
      <div class="header_btm">
        <div class="inner">
          <h1 class="logo">
            <span>한국외식산업협회</span>
            <router-link to="/main" tag="a" href="javascript:return"
              ><img src="@/assets/static/images/logo_type01.svg" alt=""
            /></router-link>
          </h1>
          <!--gnb-->
          <div class="gnb">
            <ul class="gnb_ul">
              <!--menu 1-->
              <li class="gnb_li">
                <div class="gnb_ttl">
                  <a href="javascript:return"><h2 class="h2">협회 소개</h2></a>
                </div>
                <div class="gnb_hover">
                  <ul class="gnb_hover_ul">
                    <router-link
                      tag="li"
                      to="/about/greeting"
                      class="gnb_hover_li"
                    >
                      <a href=""><p class="gnb_hover_ttl">인사말</p></a>
                    </router-link>
                    <router-link
                      tag="li"
                      to="/about/history"
                      class="gnb_hover_li"
                    >
                      <a href=""><p class="gnb_hover_ttl">협회 연혁</p></a>
                    </router-link>
<!--                    <router-link-->
<!--                      tag="li"-->
<!--                      to="/about/exctv"-->
<!--                      class="gnb_hover_li"-->
<!--                    >-->
<!--                      <a href=""><p class="gnb_hover_ttl">임원 소개</p></a>-->
<!--                    </router-link>-->
                    <router-link
                      tag="li"
                      to="/about/orgnz-chart"
                      class="gnb_hover_li"
                    >
                      <a href=""><p class="gnb_hover_ttl">조직도</p></a>
                    </router-link>
                    <router-link tag="li" to="/about/road" class="gnb_hover_li">
                      <a href=""><p class="gnb_hover_ttl">찾아오는 길</p></a>
                    </router-link>
                    <router-link tag="li" to="/about/ci" class="gnb_hover_li">
                      <a href=""><p class="gnb_hover_ttl">CI</p></a>
                    </router-link>
                  </ul>
                </div>
              </li>
              <!--//menu 1-->
              <!--menu 2-->
              <li class="gnb_li">
                <div class="gnb_ttl">
                  <a href="javascript:return"><h2 class="h2">위생 교육</h2></a>
                </div>
                <div class="gnb_hover">
                  <ul class="gnb_hover_ul">
                    <router-link
                      tag="li"
                      to="/hygn/notice"
                      class="gnb_hover_li"
                    >
                      <a href=""
                        ><p class="gnb_hover_ttl">
                          식품 위생 교육<br />안내
                        </p></a
                      >
                    </router-link>
                    <router-link
                      tag="li"
                      to="/hygn/agency"
                      class="gnb_hover_li"
                    >
                      <a href=""
                        ><p class="gnb_hover_ttl">
                          식품 위생 교육<br />전문 기관
                        </p></a
                      >
                    </router-link>
                  </ul>
                </div>
              </li>
              <!--//menu 2-->
              <!--menu 3-->
              <li class="gnb_li">
                <div class="gnb_ttl">
                  <a href="javascript:return"
                    ><h2 class="h2">외식 경영 관리사</h2></a
                  >
                </div>
                <div class="gnb_hover">
                  <ul class="gnb_hover_ul">
                    <router-link
                      tag="li"
                      to="/manager/info"
                      class="gnb_hover_li"
                    >
                      <a href=""
                        ><p class="gnb_hover_ttl">
                          외식 경영 관리사<br />안내
                        </p></a
                      >
                    </router-link>
                    <router-link
                      tag="li"
                      to="/manager/edu/apply"
                      class="gnb_hover_li"
                    >
                      <a href=""><p class="gnb_hover_ttl">교육 신청</p></a>
                      <ul>
                        <router-link tag="li" to="/manager/edu/apply">
                          <a href=""><p>교육신청</p></a>
                        </router-link>
                        <router-link tag="li" to="/manager/edu/register">
                          <a href=""><p>접수 확인 및 취소</p></a>
                        </router-link>
                      </ul>
                    </router-link>
                    <router-link
                      tag="li"
                      to="/manager/exam/apply"
                      class="gnb_hover_li"
                    >
                      <a href=""><p class="gnb_hover_ttl">시험 신청</p></a>
                      <ul>
                        <router-link tag="li" to="/manager/exam/apply">
                          <a href=""><p>시험 신청</p></a>
                        </router-link>
                        <router-link tag="li" to="/manager/exam/register">
                          <a href=""><p>접수 확인 및 취소</p></a>
                        </router-link>
                        <router-link tag="li" to="/manager/exam/admission">
                          <a href=""><p>수험표 출력</p></a>
                        </router-link>
                        <router-link tag="li" to="/manager/exam/notice">
                          <a href=""><p>공지사항</p></a>
                        </router-link>
                        <router-link tag="li" to="/manager/exam/certificate">
                          <a href=""><p>자격증 발급(재발급)</p></a>
                        </router-link>
                        <router-link tag="li" to="/manager/exam/pass">
                          <a href=""><p>합격자 조회</p></a>
                        </router-link>
                      </ul>
                    </router-link>
                  </ul>
                </div>
              </li>
              <!--//menu 3-->
              <!--menu 4-->
              <li class="gnb_li">
                <div class="gnb_ttl">
                  <a href="javascript:return"><h2 class="h2">소식 알림</h2></a>
                </div>
                <div class="gnb_hover">
                  <ul class="gnb_hover_ul">
                    <router-link tag="li" to="/news/asctn" class="gnb_hover_li">
                      <a href=""><p class="gnb_hover_ttl">협회 소식</p></a>
                    </router-link>
                    <router-link
                      tag="li"
                      to="/news/notice"
                      class="gnb_hover_li"
                    >
                      <a href=""><p class="gnb_hover_ttl">공지사항</p></a>
                    </router-link>
                    <router-link tag="li" to="/news/kfood" class="gnb_hover_li">
                      <a href=""><p class="gnb_hover_ttl">외식 산업 뉴스</p></a>
                    </router-link>
                    <router-link tag="li" to="/news/data" class="gnb_hover_li">
                      <a href=""><p class="gnb_hover_ttl">자료실</p></a>
                    </router-link>
                  </ul>
                </div>
              </li>
              <!--//menu 4-->
              <!--menu 5-->
              <li class="gnb_li">
                <div class="gnb_ttl">
                  <a href="javascript:return"><h2 class="h2">회원 공간</h2></a>
                </div>
                <div class="gnb_hover">
                  <ul class="gnb_hover_ul">
                    <router-link
                      tag="li"
                      to="/space/board"
                      class="gnb_hover_li"
                    >
                      <a href=""><p class="gnb_hover_ttl">회원 게시판</p></a>
                    </router-link>
                    <router-link
                      tag="li"
                      to="/space/promotion"
                      class="gnb_hover_li"
                    >
                      <a href=""><p class="gnb_hover_ttl">회원 홍보관</p></a>
                    </router-link>
                    <router-link
                      tag="li"
                      to="/space/banner"
                      class="gnb_hover_li"
                    >
                      <a href=""><p class="gnb_hover_ttl">배너 안내</p></a>
                    </router-link>
                  </ul>
                </div>
              </li>
              <!--//menu 5-->
              <!--menu 6-->
<!--              <li class="gnb_li">-->
<!--                <div class="gnb_ttl">-->
<!--                  <a href="javascript:return"><h2 class="h2">이용 안내</h2></a>-->
<!--                </div>-->
<!--                <div class="gnb_hover">-->
<!--                  <ul class="gnb_hover_ul">-->
<!--                    <router-link tag="li" to="/terms/use" class="gnb_hover_li">-->
<!--                      <a href=""><p class="gnb_hover_ttl">이용 약관</p></a>-->
<!--                    </router-link>-->
<!--                    <router-link-->
<!--                      tag="li"-->
<!--                      to="/terms/private"-->
<!--                      class="gnb_hover_li"-->
<!--                    >-->
<!--                      <a href=""-->
<!--                        ><p class="gnb_hover_ttl">개인정보처리방침</p></a-->
<!--                      >-->
<!--                    </router-link>-->
<!--                    <router-link-->
<!--                      tag="li"-->
<!--                      to="/terms/marketing"-->
<!--                      class="gnb_hover_li"-->
<!--                    >-->
<!--                      <a href=""-->
<!--                        ><p class="gnb_hover_ttl">-->
<!--                          제3자 마케팅 활용<br />동의서-->
<!--                        </p></a-->
<!--                      >-->
<!--                    </router-link>-->
<!--                  </ul>-->
<!--                </div>-->
<!--              </li>-->
              <!--//menu 6-->
            </ul>
          </div>
          <!--//gnb-->
        </div>
      </div>
    </div>
  </header>
</template>
<script>
export default {
  name: 'HeaderBar',
  computed: {
    layoutState: function() {
      return this.$store.getters['layout/getLayout']
    },
    userData() {
      return this.$store.getters['user/getUserData']
    }
  },
  methods: {
    fnPage: function(type = 1) {
      if (type === 1) {
        this.$router.push({ path: '/sign/up/step1' })
      } else {
        this.$router.push({ path: '/sign/in' })
      }
    },
    fnLogout: async function() {
      if (!confirm('로그아웃하시겠습니까?')) return
      const res = await this.$SignSvc.logout()
      if (res.code !== 1) {
        alert(res.message)
        return
      }
      await this.$router.replace({ path: '/main' })
    }
  }
}
</script>
<style lang="scss">
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
